import DOMPurify from "dompurify";
import { RichText } from "./RichText";

const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "u", "s", "h2", "h3",
  "ul", "ol", "li", "blockquote", "a", "span",
];
const ALLOWED_ATTR = ["href", "target", "rel", "data-font", "data-color", "style"];

// Style whitelist – vain tasaus sallitaan inline-tyylinä
const STYLE_RE = /^\s*text-align:\s*(left|center|right)\s*;?\s*$/;

const isHtml = (s: string) => /<\/?[a-z][\s\S]*>/i.test(s);

export const RichContent = ({
  html,
  className,
  fallbackBoldClassName = "font-semibold",
}: {
  html: string;
  className?: string;
  fallbackBoldClassName?: string;
}) => {
  const text = html ?? "";

  // Vanhat **bold**-tekstit: käytä legacy-renderöijää
  if (!isHtml(text)) {
    return (
      <RichText
        as="div"
        text={text}
        className={`rich-content ${className ?? ""}`}
        boldClassName={fallbackBoldClassName}
      />
    );
  }

  const clean = DOMPurify.sanitize(text, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  })
    // Pudota tyylimääritteet, jotka eivät ole whitelist-tasausta
    .replace(/style="([^"]*)"/g, (m, val) => (STYLE_RE.test(val) ? m : ""));

  return (
    <div
      className={`rich-content ${className ?? ""}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};
